import styled from "styled-components";
import { ReactComponent as IconCrossRound } from "../Images/icon_cross_round.svg";
import LayoutModal from "../Layout/LayoutModal";
import "../Styles/component.css";
import "../Styles/fonts.css";
import "../Styles/global.css";

const ImageExBox = ({ title, image, screen, handleClickX }) => {
  return (
    <ModalBox>
      <div className="hrz-wrapper center">
        <p className="bold-text" style={{ fontSize: "24px" }}>
          {title}
        </p>
      </div>
      <div className="hrz-wrapper" style={{ marginTop: "-32px" }}>
        <div style={{ marginLeft: "auto", cursor: "pointer" }}>
          <IconCrossRound onClick={handleClickX} />
        </div>
      </div>

      <ScrollBox>
        <p
          className="bold-text"
          style={{ fontSize: "18px", marginBottom: "8px" }}
        >
          이미지
        </p>
        {image}
        <p
          className="bold-text"
          style={{ fontSize: "18px", marginTop: "20px", marginBottom: "8px" }}
        >
          앱 적용 화면
        </p>
        {screen}
      </ScrollBox>
    </ModalBox>
  );
};

const ImageEx = ({ title, image, screen, handleClickX }) => {
  return (
    <LayoutModal
      Modal={
        <ImageExBox
          title={title}
          image={image}
          screen={screen}
          handleClickX={handleClickX}
        />
      }
    />
  );
};

const ModalBox = styled.div`
  width: 537px;
  height: auto;
  padding: 30px;
  border-radius: 20px;
  background-color: #ffffff;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);

  // margin-left: 662px;
  // margin-top: 122.75px;
`;

const ScrollBox = styled.div`
  width: 100%;
  height: 659px;
  margin-top: 20px;
  box-sizing: border-box;
  padding-right: 8px;
  overflow-x: hidden;
  overflow-y: scroll;
  > img,
  > svg {
    display: block;
    width: 100%;
    height: auto;
  }
  &::-webkit-scrollbar {
    width: 6px;
    z-index: 1;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #b0b0b0;
    border-radius: 10px;
  }
`;

export default ImageEx;
